export default "__VITE_ASSET__QoyuTYO0__"